import React, { useState, useEffect } from 'react';
import { getConsent, saveConsent, initGA } from '../../utils/cookieConsent';

const CookieConsentBanner = () => {
  const [visible, setVisible] = useState(false);
  const [showPreferences, setShowPreferences] = useState(false);
  const [analyticsEnabled, setAnalyticsEnabled] = useState(true);

  useEffect(() => {
    const consent = getConsent();
    if (!consent) setVisible(true);
  }, []);

  if (!visible) return null;

  const handleAcceptAll = () => {
    saveConsent(true);
    initGA();
    setVisible(false);
  };

  const handleSavePreferences = () => {
    saveConsent(analyticsEnabled);
    if (analyticsEnabled) initGA();
    setVisible(false);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9999] p-4">
      <div
        className="max-w-2xl mx-auto rounded-xl shadow-2xl border p-5"
        style={{
          backgroundColor: 'rgb(var(--color-bg-secondary))',
          borderColor: 'rgb(var(--color-border-primary))',
        }}
      >
        {!showPreferences ? (
          /* ── Main banner ── */
          <>
            <p className="text-sm mb-4" style={{ color: 'rgb(var(--color-text-tertiary))' }}>
              We use cookies to improve your experience and analyze site usage.{' '}
              <a
                href="/cookies"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#22c55e] hover:underline"
              >
                See our Cookies Policy for details.
              </a>
            </p>
            <div className="flex flex-col sm:flex-row gap-2">
              <button
                onClick={handleAcceptAll}
                className="flex-1 bg-[#16a34a] hover:bg-[#15803d] text-white text-sm font-medium py-2.5 px-4 rounded-lg transition-colors"
              >
                Accept All
              </button>
              <button
                onClick={() => setShowPreferences(true)}
                className="flex-1 text-sm font-medium py-2.5 px-4 rounded-lg border transition-colors"
                style={{
                  borderColor: 'rgb(var(--color-border-primary))',
                  color: 'rgb(var(--color-text-primary))',
                  backgroundColor: 'transparent',
                }}
              >
                Manage Preferences
              </button>
            </div>
          </>
        ) : (
          /* ── Preferences panel ── */
          <>
            <h3
              className="text-base font-bold mb-4"
              style={{ color: 'rgb(var(--color-text-primary))' }}
            >
              Cookie Preferences
            </h3>

            {/* Essential toggle — always on */}
            <div className="flex items-center justify-between mb-4">
              <div className="flex-1 pr-4">
                <p className="text-sm font-medium" style={{ color: 'rgb(var(--color-text-primary))' }}>
                  Essential Cookies
                </p>
                <p className="text-xs mt-0.5" style={{ color: 'rgb(var(--color-text-secondary))' }}>
                  Required for the app to function. Cannot be disabled.
                </p>
              </div>
              <div className="w-11 h-6 bg-[#16a34a] rounded-full relative flex-shrink-0 opacity-60 cursor-not-allowed">
                <div className="absolute right-1 top-1 w-4 h-4 bg-white rounded-full" />
              </div>
            </div>

            {/* Analytics toggle */}
            <div className="flex items-center justify-between mb-5">
              <div className="flex-1 pr-4">
                <p className="text-sm font-medium" style={{ color: 'rgb(var(--color-text-primary))' }}>
                  Analytics Cookies
                </p>
                <p className="text-xs mt-0.5" style={{ color: 'rgb(var(--color-text-secondary))' }}>
                  Help us understand how you use Loft (Google Analytics).
                </p>
              </div>
              <button
                role="switch"
                aria-checked={analyticsEnabled}
                onClick={() => setAnalyticsEnabled(prev => !prev)}
                className={`w-11 h-6 rounded-full relative flex-shrink-0 transition-colors ${
                  analyticsEnabled ? 'bg-[#16a34a]' : 'bg-gray-600'
                }`}
              >
                <div
                  className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-transform ${
                    analyticsEnabled ? 'translate-x-5' : 'translate-x-1'
                  }`}
                />
              </button>
            </div>

            <div className="flex flex-col sm:flex-row gap-2">
              <button
                onClick={handleSavePreferences}
                className="flex-1 bg-[#16a34a] hover:bg-[#15803d] text-white text-sm font-medium py-2.5 px-4 rounded-lg transition-colors"
              >
                Save Preferences
              </button>
              <button
                onClick={() => setShowPreferences(false)}
                className="flex-1 text-sm font-medium py-2.5 px-4 rounded-lg border transition-colors"
                style={{
                  borderColor: 'rgb(var(--color-border-primary))',
                  color: 'rgb(var(--color-text-primary))',
                  backgroundColor: 'transparent',
                }}
              >
                Back
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CookieConsentBanner;
